<div class="row">
	<div *ngFor="let collection of collections; let i = index" class="col-lg-4">
		<kt-collections-card
			(btnClick)="collectionClick.emit($event)"
			[status]="dynamicBtnStyle(i)"
			[collection]="collection"
		></kt-collections-card>
	</div>
</div>
